import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayDateTimeGeneral } from '../Displayers/TEDDisplayDateTimeGeneral';
import { TEDParseDateTimeGeneral } from '../Parsers/TEDParseDateTimeGeneral';

class TEDFormatDateTimeGeneral implements IFormatter {
  displayer = TEDDisplayDateTimeGeneral.getInstance();
  parser = TEDParseDateTimeGeneral.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatDateTimeGeneral };
